export enum SeasonStatuses {
  ACTIVE = "ACTIVE",
  COMPLETED = "COMPLETED",
  PENDING = "PENDING",
  INACTIVE = "INACTIVE",
}
